jQuery(function () {
	// The autoComplete.js Engine instance creator
	// eslint-disable-next-line no-undef
	const autoCompletePosition = new autoComplete({
		selector: '#autoCompletePosition',
		data: {
			src: async () => {
				try {
					// Fetch External Data Source
					const source = await fetch(`${window.ZENGIG_MICROSERVICE.route}/job-positions/all`);
					// Returns Fetched data
					return await source.json();
				} catch (error) {
					return error;
				}
			},
			cache: true,
			filter: (list) => {
				// Filter duplicates
				// incase of multiple data keys usage
				const filteredResults = Array.from(new Set(list.map((value) => value.match))).map((position) => {
					return list.find((value) => value.match === position);
				});

				return filteredResults;
			},
		},
		placeHolder: 'Search by title',
		resultsList: {
			element: (list, data) => {
				const info = document.createElement('p');
				if (data.results.length > 0) {
					info.innerHTML = `Displaying <strong>${data.results.length}</strong> out of <strong>${data.matches.length}</strong> results`;
				} else {
					info.innerHTML = `Found <strong>${data.matches.length}</strong> matching results for <strong>"${data.query}"</strong>`;
				}
				list.prepend(info);
			},
			noResults: true,
			maxResults: 70,
			tabSelect: true,
		},
		resultItem: {
			element: (item, data) => {
				// Modify Results Item Style
				item.style = 'display: flex; justify-content: space-between;';
				// Modify Results Item Content
				item.innerHTML = `
								<span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
									${data.match}
								</span>`;
			},
			highlight: true,
		},
		events: {
			input: {
				focus: () => {
					if (autoCompletePosition.input.value.length) autoCompletePosition.start();
				},
			},
		},
	});

	autoCompletePosition.input.addEventListener('selection', function (event) {
		const feedback = event.detail;
		autoCompletePosition.input.blur();
		// Prepare User's Selected Value
		// Render selected choice to selection div

		// Replace Input value with the selected value
		autoCompletePosition.input.value = feedback.selection.value;
	});

	/**
	 * The autoComplete.js Engine instance creator
	 */
	const autoCompleteLocations =
		// eslint-disable-next-line no-undef
		new autoComplete({
			selector: '#inputAutoCompleteLocation',
			data: {
				src: async () => {
					try {
						// Fetch External Data Source
						const source = await fetch(`${window.ZENGIG_MICROSERVICE.route}/job-markets/all`);
						// Returns Fetched data
						return await source.json();
					} catch (error) {
						return error;
					}
				},
				cache: true,
				filter: (list) => {
					// Filter duplicates
					// incase of multiple data keys usage
					return Array.from(new Set(list.map((value) => value.match))).map((position) => {
						return list.find((value) => value.match === position);
					});
				},
			},
			resultsList: {
				render: true,
				element: (list, data) => {
					const info = document.createElement('p');
					if (data.results.length > 0) {
						info.innerHTML = `Displaying <strong>${data.results.length}</strong> out of <strong>${data.matches.length}</strong> results`;
					} else {
						info.innerHTML = `Found <strong>${data.matches.length}</strong> matching results for <strong>"${data.query}"</strong>`;
					}
					list.prepend(info);
				},
				noResults: true,
				maxResults: 15,
				tabSelect: true,
			},
			resultItem: {
				element: (item, data) => {
					// Modify Results Item Style
					item.style = 'display: flex; justify-content: space-between;';
					// Modify Results Item Content
					item.innerHTML = `<span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
									${data.match}
								</span>`;
				},
				highlight: true,
			},
			events: {
				input: {
					focus: () => {
						if (autoCompleteLocations.input.value.length) autoCompleteLocations.start();
					},
				},
			},
		});

	autoCompleteLocations.input.addEventListener('selection', function (event) {
		const feedback = event.detail;
		autoCompleteLocations.input.blur();
		// Prepare User's Selected Value
		// Render selected choice to selection div

		// Replace Input value with the selected value
		autoCompleteLocations.input.value = feedback.selection.value;
	});
});
